// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects-container {
  margin-left: auto;
  margin-right: auto;
  width: 85%;
  min-height: 85%;
  margin-top: 7vh;
  /*only applies on sm*/
  margin-bottom: 100px;
}

.imgContainer {
  height: 16vh;
  width: 10vw;
  overflow: hidden;
  font-size: 0.5em;
  background-position: left center !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  display: inline-block;
}

h3 {
  width: 100%;
  text-align: center;
  padding: 20px;
  padding-bottom: 0;
}

.items {
  width: 100%;
  height: 100%;
  table-layout: fixed;
}
.items td {
  text-align: left;
  font-size: 1.5vw;
  width: 50%;
}
.items td article {
  padding-left: 7vw;
  width: 100%;
}

.row div {
  padding: 0;
}

.projectTitle {
  display: inline-block;
  max-width: calc(100% - 12vw);
  position: relative;
  top: -60px;
  left: 20px;
  font-size: clamp(0.8em, 1.1vw, 1.25em);
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  line-height: 1.2;
  vertical-align: middle;
}

h2 {
  background-color: rgb(0, 32, 96);
  margin-bottom: 20px;
  text-align: center;
  padding: 10px;
  padding-left: 3%;
}

a {
  display: block;
  text-decoration: none;
  padding: 10px;
  color: white;
}
a .fas {
  padding: 15px;
}

p {
  padding: 5px;
}

article {
  position: relative;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
}
article .description {
  font-size: 0.95em;
  display: inline-block;
  width: 60%;
  vertical-align: top;
  left: 50%;
}

.small .imgContainer {
  height: 100px;
  width: 30vw;
  margin-left: 10px;
}
.small .items td {
  font-size: 1em;
}
.small .projectTitle {
  top: -5vh;
  max-width: calc(100% - 35vw);
  font-size: clamp(0.7em, 3vw, 1em);
}

@media screen and (max-width: 991px) {
  .projects-container {
    height: auto !important;
    min-height: auto;
    margin-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/projects-section/projects-section.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CAAA;EACA,uCAAA;EACA,mCAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AACF;AAAE;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;AAEJ;AADI;EACE,iBAAA;EACA,WAAA;AAGN;;AAGE;EACE,UAAA;AAAJ;;AAIA;EACE,qBAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,sCAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;AADF;AAGE;EACE,aAAA;AADJ;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AAFF;AAIE;EACE,iBAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,SAAA;AAFJ;;AAOE;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AAJJ;AAOI;EACE,cAAA;AALN;AAQE;EACE,SAAA;EACA,4BAAA;EACA,iCAAA;AANJ;;AAUA;EACE;IACE,uBAAA;IACA,gBAAA;IACA,aAAA;EAPF;AACF","sourcesContent":[".projects-container {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  width: 85%;\r\n  min-height: 85%;\r\n  margin-top: 7vh;\r\n  /*only applies on sm*/\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.imgContainer {\r\n  height: 16vh;\r\n  width: 10vw;\r\n  overflow: hidden;\r\n  font-size: 0.5em;\r\n  background-position: left center !important;\r\n  background-repeat: no-repeat !important;\r\n  background-size: contain !important;\r\n  display: inline-block;\r\n}\r\n\r\nh3 {\r\n  width: 100%;\r\n  text-align: center;\r\n  padding: 20px;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.items {\r\n  width: 100%;\r\n  height: 100%;\r\n  table-layout: fixed;\r\n  td {\r\n    text-align: left;\r\n    font-size: 1.5vw;\r\n    width: 50%;\r\n    article {\r\n      padding-left: 7vw;\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n.row {\r\n  div {\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.projectTitle {\r\n  display: inline-block;\r\n  max-width: calc(100% - 12vw);\r\n  position: relative;\r\n  top: -60px;\r\n  left: 20px;\r\n  font-size: clamp(0.8em, 1.1vw, 1.25em);\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  hyphens: auto;\r\n  line-height: 1.2;\r\n  vertical-align: middle;\r\n}\r\n\r\nh2 {\r\n  background-color: rgba(0, 32, 96, 1);\r\n  margin-bottom: 20px;\r\n  text-align: center;\r\n  padding: 10px;\r\n  padding-left: 3%;\r\n}\r\n\r\na {\r\n  display: block;\r\n  text-decoration: none;\r\n  padding: 10px;\r\n  color: white;\r\n\r\n  .fas {\r\n    padding: 15px;\r\n  }\r\n}\r\n\r\np {\r\n  padding: 5px;\r\n}\r\n\r\narticle {\r\n  position: relative;\r\n  display: inline-block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n\r\n  .description {\r\n    font-size: 0.95em;\r\n    display: inline-block;\r\n    width: 60%;\r\n    vertical-align: top;\r\n    left: 50%;\r\n  }\r\n}\r\n\r\n.small {\r\n  .imgContainer {\r\n    height: 100px;\r\n    width: 30vw;\r\n    margin-left: 10px;\r\n  }\r\n  .items {\r\n    td {\r\n      font-size: 1em;\r\n    }\r\n  }\r\n  .projectTitle {\r\n    top: -5vh;\r\n    max-width: calc(100% - 35vw);\r\n    font-size: clamp(0.7em, 3vw, 1em);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .projects-container {\r\n    height: auto !important;\r\n    min-height: auto;\r\n    margin-top: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
